import { SalaryIncreaseType } from '../../../../core/models/salary-increase-type';

/** Index 0..4 of the value arrays = note 1..5. */
export const GRID_NOTE_INDEXES: readonly number[] = [0, 1, 2, 3, 4];

export type RemunerationGridField = 'bonusAmounts' | 'increasePercents';
export type RemunerationGridTypeField = 'bonusType' | 'increaseType';
export type RemunerationGridSetField = 'bonusFixedAmounts' | 'bonusPercentages' | 'increaseAmounts' | 'increasePercentages';
export type RemunerationGridTableType = SalaryIncreaseType | 'MIXED';

export interface RemunerationGridRow {
  categoryShortLabel: string;
  level: number;
  bonusAmounts: number[];
  increasePercents: number[];
  increaseAmounts: number[];
  increasePercentages: number[];
  increaseType?: SalaryIncreaseType;
  bonusType?: SalaryIncreaseType;
  bonusFixedAmounts?: number[];
  bonusPercentages?: number[];
}

export interface RemunerationGrid {
  year: number;
  practice: string;
  /** True when the year + practice has values saved in the database. */
  saved: boolean;
  /** The earlier year the values were copied from (only when saved = false). */
  copiedFromYear: number | null;
  increaseType?: SalaryIncreaseType | null;
  bonusType?: SalaryIncreaseType | null;
  rows: RemunerationGridRow[];
}

export interface RemunerationGridRowInput {
  categoryShortLabel: string;
  bonusAmounts: number[];
  increasePercents: number[];
  increaseAmounts: number[];
  increasePercentages: number[];
  increaseType: SalaryIncreaseType;
  bonusType: SalaryIncreaseType;
  bonusFixedAmounts: number[];
  bonusPercentages: number[];
}
